import React, { useEffect } from "react";
import { Grid, Button, Card, Popper, Grow, MenuList, MenuItem, Paper, ClickAwayListener, ButtonGroup } from '@material-ui/core';
import { useSelector, useDispatch } from "react-redux";
import TableGeneric from "../../../compartidos/abms/TableGeneric";
import { makeStyles } from "@material-ui/core/styles";
import moment from 'moment';
import { DescargarPlantillaExcel, getMedicamentos310, SubirArchivoExcel } from "../../../../actions/empadronamiento/Medicamentos310";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import BuscadorMedicamentos310 from "./BuscadorMedicamentos310";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";


const useStyles = makeStyles({
  botonera: {
    padding: 25
  }
});

export const HomeMedicamentos310 = (props) => {
  const { items = [] } = useSelector((state) => state.medicamentos310);

  const dispatch = useDispatch();
  const classes = useStyles();

  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);
  const [selectedIndex, setSelectedIndex] = React.useState(1);

  useEffect(() => {
    //dispatch(getMedicamentos310(null, selectedMedicamentoActivo));
  }, [dispatch]);

  const handleSearch = (activosPorFecha, medicamentoFiltro, fechaDesde, fechaHasta) => {
    dispatch(getMedicamentos310(medicamentoFiltro === "" ? null : medicamentoFiltro, activosPorFecha,
      fechaDesde, fechaHasta));
  }

  const handleChangeFile = (e) => {
    dispatch(SubirArchivoExcel(e.target.files[0]));
    e.target.value = null;
  };

  const handleMenuItemClick = (event, index) => {
    setSelectedIndex(index);
    setOpen(false);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  const downloadFile = () => {
    dispatch(DescargarPlantillaExcel());
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  return (
    <div>
      <Grid container justify="center">
        <Grid item xs={12}>
          <ButtonGroup
            variant="contained"
            color="inherit"
            ref={anchorRef}
            aria-label="split button"
            style={{
              boxShadow: "none",
              width: "100%",
              justifyContent: "center",
              marginTop: "1rem",
            }}
          >
            {selectedIndex === 0 && (
              <>
                <input
                  accept="*/*"
                  //   className={classes.input}
                  style={{ display: "none" }}
                  id="selectArchivoExcel"
                  multiple
                  type="file"
                  onChange={handleChangeFile}
                />
                <Button
                  component="span"
                  variant="contained"
                  color="primary"
                  startIcon={<CloudUploadIcon />}
                  style={{ borderRadius: "3px 0px 0px 3px" }}
                  onClick={() =>
                    document.querySelector(`#selectArchivoExcel`).click()
                  }
                >
                  Subir Plantilla
                </Button>
              </>
            )}
            {selectedIndex === 1 && (
              <Button
                component="span"
                variant="contained"
                color="primary"
                style={{ borderRadius: "3px 0px 0px 3px" }}
                startIcon={<CloudDownloadIcon />}
                onClick={downloadFile}
              >
                Descargar Plantilla{" "}
              </Button>
            )}
            <Button
              color="primary"
              size="small"
              aria-controls={open ? "split-button-menu" : undefined}
              aria-expanded={open ? "true" : undefined}
              aria-label="select merge strategy"
              aria-haspopup="menu"
              onClick={handleToggle}
            >
              <ArrowDropDownIcon />
            </Button>
          </ButtonGroup>
          <Popper
            open={open}
            anchorEl={anchorRef.current}
            role={undefined}
            transition
            disablePortal
            style={{ zIndex: 1}}
          >
            {({ TransitionProps, placement }) => (
              <Grow
                {...TransitionProps}
                style={{
                  transformOrigin:
                    placement === "bottom" ? "center top " : "center bottom"
                }}
              >
                <Paper>
                  <ClickAwayListener onClickAway={handleClose}>
                    <MenuList id="split-button-menu" >
                      <MenuItem
                        selected={0 === selectedIndex}
                        onClick={(event) => handleMenuItemClick(event, 0)}
                      >
                        Subir Plantilla
                      </MenuItem>
                      <MenuItem
                        selected={1 === selectedIndex}
                        onClick={(event) => handleMenuItemClick(event, 1)}
                      >
                        Descargar Plantilla
                      </MenuItem>
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>
        </Grid>
      </Grid>

      <Grid container justify="center">
        <Grid item xs={12} md={5} className={classes.root} style={{ marginTop: "1rem" }}>
          <BuscadorMedicamentos310
            handleSearch={handleSearch}
          />
        </Grid>
        <Grid item xs={12} md={12} style={{ marginTop: "2rem" }} >
          <Card>
            <TableGeneric
              data={items}
              columns={[
                {
                  label: "Id",
                  id: "idSSS",
                  sort: true
                },
                {
                  label: "Atc",
                  id: "atc",
                  sort: true
                },
                {
                  label: "Nombre",
                  id: "medicamento.nombre",
                  sort: true
                },
                {
                  label: "Presentacion",
                  id: "medicamento.presentacion",
                  sort: true
                },
                {
                  label: "Pvp",
                  id: "pvp",
                  sort: true
                },
                {
                  label: "A cargo OS",
                  id: "aCargoOs",
                  sort: true
                },
                {
                  label: "A cargo Afiliado",
                  id: "aCargoAfi",
                  sort: true
                },
                {
                  label: "Laboratorio",
                  id: "medicamento.laboratorio",
                  sort: true
                },
                {
                  label: "Registro",
                  id: "medicamento.idMedicamento",
                  sort: true
                },
                {
                  label: "PR",
                  id: "pr",
                  sort: true
                },
                {
                  label: "Grupoter",
                  id: "grupoTer",
                  sort: true
                },
                {
                  label: "Observaciones",
                  id: "observaciones",
                  sort: true
                },
                {
                  label: "Troquel",
                  id: "medicamento.troquel",
                  sort: true
                },
                {
                  label: "Desde",
                  id: "fechaDesde",
                  sort: true,
                  customBody: (item) => item.fechaDesde ? moment(item.fechaDesde).format('DD/MM/YYYY') : ""
                },
                {
                  label: "Hasta",
                  id: "fechaHasta",
                  sort: true,
                  customBody: (item) => item.fechaHasta ? moment(item.fechaHasta).format('DD/MM/YYYY') : ""
                },
                {
                  label: "Fecha Carga",
                  id: "fechaCarga",
                  sort: true,
                  customBody: (item) => item.fechaCarga ? moment(item.fechaCarga).format('DD/MM/YYYY') : ""
                },
                {
                  label: "Generico",
                  id: "medicamento.drogas",
                  sort: true
                },
              ]}
            />
          </Card>
        </Grid>
      </Grid>
    </div>
  );

};

export default HomeMedicamentos310; 
